<template>
  <div class="lg:px-12 md:px-12 px-5 lg:py-16 md:py-12 py-8">
    <div class="container mx-auto flex justify-center">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
        class="tabs-bottom-none bdr-bottom-none"
      >
        <el-tab-pane
          label="About & Types"
          name="first"
          class="{ 'custom-active-tab': activeName === 'first' }"
          ><AboutCancer
        /></el-tab-pane>
        <el-tab-pane label="Symptoms" name="second"
          ><Symptoms
        /></el-tab-pane>
        <el-tab-pane label="Treatment & Care" name="third"
          ><SideEffects
        /></el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import AboutCancer from "../AboutCancer.vue";
import Symptoms from "./Symptoms.vue";
import SideEffects from "../SideEffects.vue";
import EmotionalSupport from "../EmotionalSupport.vue";
import Nutrition from "../Nutrition.vue";
import FinancialSupport from "../FinancialSupport.vue";
import { mapState } from "vuex";
export default {
  components: {
    AboutCancer,
    Symptoms,
    SideEffects,
    EmotionalSupport,
    Nutrition,
    FinancialSupport,
  },
  data() {
    return {
      activeName: "first",
    };
  },
  methods: {
    async handleClick(tab) {
      console.log(tab);
      let payload = {
        category: "Cancer",
        subcategory: tab.label,
        active: true,
      };
      await this.$store.dispatch("medicalFaq/getFilteredMedicalFaq", payload);
    },
  },
  computed: {
    ...mapState("medicalFaq", ["FilteredMedicalFaq"]),
  },
  async mounted() {
    await this.handleClick({ label: "About Cancer" });
  },
};
</script>
<style scoped>
/* Scoped styles using ::v-deep for deep selector */
::v-deep .el-tabs__nav-wrap::after {
  background-color: transparent !important;
  height: 0px !important;
}

::v-deep .el-tabs__active-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 0pxn !important;
  background-color: transparent !important;
  z-index: 1;
  -webkit-transition: -webkit-transform 0.3s
    cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  list-style: none;
}

::v-deep .el-tabs__header .el-tab {
  background-color: #f0f0f0;
  color: #333;
  padding: 12px 20px;
  font-size: 16px;
  border-radius: 8px;
  transition: background-color 0.3s ease;
}

::v-deep .el-tabs__item.is-active {
  color: #ffffff !important;
  background-color: #4f0a4b !important;
  border: 1px solid #4f0a4b !important;
}

::v-deep .el-tabs__item {
  padding: 0px 26px !important;
  margin-right: 15px !important;
  height: 38px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 38px;
  display: inline-block;
  list-style: none;
  font-size: 14px;
  font-weight: 500;
  color: #4f4f4f;
  border: 1px solid #4f4f4f;
  position: relative;
  border-radius: 6px !important;
}

::v-deep .el-tabs__header .el-tab i {
  margin-right: 8px; /* Add some space between icon and text */
}
</style>
